/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { ReactNode } from "react";
import { AbstractIntlMessages, NextIntlClientProvider } from "next-intl";
import CaptureUTMParameters from "../../hooks/use-persist-utm.hook";

interface IntlProviderProps {
  locale: string;
  now?: Date; // Optional and can be a Date object, a string, or a timestamp.
  timeZone?: string; // Optional, can be any valid time zone string.
  messages: AbstractIntlMessages; // Localization messages as an object.
  children: ReactNode; // The component's children.
}
export default function IntlProvider({ locale, now, timeZone, messages, children }: IntlProviderProps) {
  CaptureUTMParameters();
  return (
    <NextIntlClientProvider
      // Define non-serializable props here
      defaultTranslationValues={{
        i: (text) => <i>{text}</i>
      }}
      onError={(error) => console.error(error)}
      getMessageFallback={({ namespace, key }) => `${namespace}.${key}`}
      // Make sure to forward these props to avoid markup mismatches
      locale={locale}
      now={now}
      timeZone={timeZone}
      // Provide as necessary
      messages={messages}
    >
      {children}
    </NextIntlClientProvider>
  );
}
